import { ProfileReportItem, ReportType } from '../../../..';
import { FormBuilder, FormControl } from '@angular/forms';

export interface AutomotiveAftermarketReport {
  deliveryNote: ProfileReportItem[];
  handlingUnit: ProfileReportItem[];
}

export class AutomotiveAftermarketProfileReport {
  deliveryNote: ProfileReportItem[] = [];
  handlingUnit: ProfileReportItem[] = [];
  type: ReportType = null;

  constructor(params?: AutomotiveAftermarketProfileReport) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AutomotiveAftermarketProfileReportForm {
  constructor(
    model: Partial<AutomotiveAftermarketProfileReport>,
    fb: FormBuilder = new FormBuilder(),
    public deliveryNote: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.deliveryNote, []),
    public handlingUnit: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.handlingUnit, []),
    public type: FormControl<ReportType> = fb.control<ReportType>(model.type, []),
  ) {}
}
